import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { tradingKeys } from '../tradingQueryKeys'
import { getSellerListings } from '../tradingEndpoints'
import { parseSellerListings } from '../tradingParser'

// Every open seller listing for one property (Listings — All Sellers), best
// discount first. Never carries seller identity.
export function useSellerListingsQuery(propertyId: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: computed(() => tradingKeys.sellerListingsFor(toValue(propertyId))),
    queryFn: () => getSellerListings(toValue(propertyId)).then(parseSellerListings),
    enabled: () => Boolean(toValue(propertyId)),
  })
}
